import { signInWithEmailAndPassword } from "firebase/auth";
import React, { useState } from "react";
import { auth } from "./firebase";
import { toast } from "react-toastify";
import SignInwithGoogle from "./signInWIthGoogle";
import "./Login.css";
import headimg from './ing.png';

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      console.log("User logged in Successfully");
      window.location.href = "/dashboard";
      toast.success("User logged in Successfully", {
        position: "top-center",
      });
    } catch (error) {
      console.log(error.message);

      toast.error(error.message, {
        position: "bottom-center",
      });
    }
  };

  return (
    <div className="flex bg">
    <form onSubmit={handleSubmit}>
      {/* <h3>Login</h3> */}

  <div className="f-box">

  <img
            src={headimg}
            alt="Logo"
            style={{
              height: '200px',
              marginTop: '0px',
            }}
          />

      <div className="input">
        <label className="leb">Email address</label>
        <input
          type="email"
          className=""
          placeholder="Enter email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>

      <div className="input">
        <label className="leb">Password</label>
        <input
          type="password"
          className=""
          placeholder="Enter password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>

      <div className="">
        <button type="submit" className="loginbtn">
          Login
        </button>
      </div>

      </div>
      {/* <p className="forgot-password text-right">
        New user <a href="/register">Register Here</a>
      </p> */}
      {/* <SignInwithGoogle/> */}
    </form>

    </div>
  );
}

export default Login;
